import { Refresh } from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import { useAlert } from '../../../../context/AlertContext';
import useSystemMasterList from '../../../../hooks/useSystemMasterList';
import AppLayout from '../../../../layout/components/AppLayout'
import taskServices from '../taskServices'
import moment from 'moment'
function TaskArchivedList() {

    const [taskList,setTaskList] = useState(null);
    const {AppAlert} = useAlert()

    const masterList = ['client','priority','project','task-status'];
    const [masters,getMasterLabel] = useSystemMasterList(masterList);

    const getTaskList = () =>{
        taskServices.getArchivedList().then(res=>{
            setTaskList(res.data)
        })
    }

    useEffect(()=>{
        getTaskList()
    },[]);

    const restore = (id) =>{
        taskServices.restore(id).then(res=>{
            getTaskList();
            AppAlert("Restored")

        })
    }

    return (
        <AppLayout>
            <div className="container-fluid">
                <div class="row">
                    <div className="col-md-3">
                    </div>
                    <div className="col-md-9">
                        <div className="card">
                            <div className="card-body">
                                <table className="table">
                                    <thead>

                                    </thead>
                                    {taskList &&
                                        <tbody>
                                            {taskList.map(task=>
                                                <tr>
                                                    <td>{task.title}</td>
                                                    <td>{getMasterLabel("client",task.clientId)}</td>
                                                    <td>{getMasterLabel("project",task.projectId)}</td>
                                                    <td>{moment(task.updated_at).fromNow()}  </td>
                                                    <td> <button className="btn btn-primary" type="button" onClick={()=>restore(task.id)}> <Refresh/> </button> </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    }

                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default TaskArchivedList